import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule } from '@angular/forms';
import { AuthService } from '../../shared/services/auth/auth.service';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import {TranslateService} from '@ngx-translate/core';
import {StaticValueService} from '../../shared/services/static-value.service'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    form: FormGroup;                    // {1}
    error: string;
    public formSubmitAttempt: boolean; // {2}
    public language='english';
    constructor(
        public fb: FormBuilder,         // {3}
        public authService: AuthService,
        public mobileNav: MobileNavService,
        public translateService:TranslateService,
        public staticService:StaticValueService
    ) { 
       
    }


    ngOnInit() {
        this.form = this.fb.group({     // {5}
            email: ['', Validators.required],
            password: ['', Validators.required]
        });
        if (this.staticService.getLanguage()) {
            this.translateService.use(this.staticService.getLanguage());
            // this.language=this.staticService.getLanguage();
        } else {
            this.translateService.use('english')
            this.translateService.setDefaultLang('english');
        }
        this.staticService.getStaticValues();
    }

    isFieldInvalid(field: string) { // {6}
        return (
            (!this.form.get(field).valid && this.form.get(field).touched ) ||
            (this.form.get(field).untouched && this.formSubmitAttempt && this.form.get(field).invalid)
        );
    }

    onClickMe() {
        this.mobileNav.showSideNav();
    }

    onSubmit() {
        if (this.form.valid) {
            this.authService.login(this.form.value)
                .then(
                    res => { // Success
                        console.log('successful login');
                        this.error = '';
                    },
                    err => {
                        this.form.get('password').reset();
                        // this.error = 'Username or password is incorrect';
                        this.error = err.error.message;
                        console.log(err)
                    }
                ); // {7}
        }
        this.formSubmitAttempt = true;             // {8}
    }

    languageChange(lang: string) {
        this.translateService.use(lang);
        this.language = lang;
        this.staticService.setLanguage(lang);
    }

    loginWithLinkedin() {
        this.authService.linkedinSignUp('', true).subscribe(res => {
            window.location.href = res['linkedinUrl'];
          }, err => {
          });
    }

    loginWithLine() {
        this.authService.lineSignUp('', true).subscribe(res => {
            window.location.href = res['lineUrl'];
          }, err => {
          });
    }


   
}
